import React from 'react';
// material-ui

const Logo = ({ src }) => {
    return <img src={src} alt="Berry" width={50} />;
};

export default Logo;
